import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type * as fhirTypes from "fhir/r4";

interface DispenseUnitsResponse {
  dispenseUnits: fhirTypes.CodeableConcept[];
}

export const useDispenseUnits = () => {
  return useApi<DispenseUnitsResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<DispenseUnitsResponse>(
          "/rx/medications/drug-info/dispense-units",
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.DrugUnits,
    },
  });
};
